import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import { NotificationsService} from "@logbook/shared";
import {Observable} from "rxjs";
import {Intercom} from "ng-intercom";
import {MixpanelService} from "@logbook/core/tracking/mixpanel.service";
import {MixpanelEvent} from "@logbook/core/tracking/mixpanel-event.enum";
import {Principal} from "@logbook/core/auth/services/principal.service";
import {AccountService} from "@logbook/core/auth/services/account.service";
import {User} from "@logbook/core/shared/models/user.model";
import {first, startWith} from "rxjs/operators";
import {fromPromise} from "rxjs/internal-compatibility";

@Component({
    selector: 'dln-registe-confirm',
    templateUrl: './sign-up-confirm.component.html',
    styleUrls: [
        'sign-up-confirm.scss'
    ]
})
export class SignUpConfirmComponent implements OnInit {

    error: string;
    userForm: FormGroup;
    success: boolean;
    loadingForm: boolean;
    currentUser: User;

    constructor(private principal: Principal, private account: AccountService,
                private router: Router, private notificationsService: NotificationsService,
                private mixpanelService: MixpanelService, private intercomService: Intercom) {
    }

    ngOnInit() {
        const {minLength, maxLength} = Validators;
        this.userForm = new FormGroup({
            firstName: new FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            lastName: new FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            pendingCompany: new FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            phone: new FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            positionInCompany: new FormControl(null, [
                minLength(1),
                maxLength(40)
            ])
        });
        this.success = false;
        this.loadingForm = false;

        this.principal.getAuthenticationState().pipe(startWith(this.principal.identityDirect()))
            .subscribe((user: User) => {
                this.currentUser = user;
            })
    }

    get firstName() {
        return this.userForm.get('firstName');
    }

    get lastName() {
        return this.userForm.get('lastName');
    }

    get pendingCompany() {
        return this.userForm.get('pendingCompany');
    }

    get positionInCompany() {
        return this.userForm.get('positionInCompany');
    }

    get phone() {
        return this.userForm.get('phone');
    }

    save() {
        if (this.userForm.invalid) {
            this.error = 'ERROR';
        } else {
            const body = this.userForm.value;
            body.userId = this.currentUser.userId;
            body.email = this.currentUser.email;
            body.phones = [this.phone.value];
            // in case of invited people, company is already set and pendingCompany must stay undefined
            let pendingCompanyNom = '';
            // in case of company not set yet, pendingCompany must be settable
            if (body.pendingCompany) {
                pendingCompanyNom = body.pendingCompany.nom;
                body.pendingCompany = body.pendingCompany.id;
            }
            this.account.save(body).pipe(first()).subscribe(() => {
                this.error = null;
                this.notificationsService.success("Account update", 'Your account has been successfully updated');
                this.mixpanelService.track(MixpanelEvent.ACCOUNT_DETAIL_CHANGE);
                this.intercomService.boot({
                    user_id: body.userId,
                    companies: [{
                        name: pendingCompanyNom,
                        company_id: pendingCompanyNom
                    }]
                });
                this.principal.identity(true).then(() => {
                    this.router.navigate(["/"])
                });
            }, () => {
                this.notificationsService.error("Account update", 'Your account cannot be update');
                this.success = null;
                this.error = 'ERROR';
            });
        }
    }

    goHome() {
        this.router.navigateByUrl("/")
    }
}
